// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UV1_","importantInfo":"styles_importantInfo__1gS5O"};